import React, { useMemo, useState, useEffect } from "react";
import axios from "axios";
import { useFormik } from "formik";
import $ from "jquery";
import JsPDF from "jspdf";
import "jspdf-autotable";
import Papa from "papaparse";
import DataTable from "react-data-table-component";
import HtmlParser from "react-html-parser";
import { useHistory, useParams } from "react-router";
import Select from "react-select";
import SortableTree from "react-sortable-tree";
import TreeTheme from "react-sortable-tree-theme-minimal";
import { Placeholder } from "semantic-ui-react";
import Swal from "sweetalert2";
import * as XLSX from "xlsx";
import * as Yup from "yup";
import { usePermissionGuardRedirect } from "../../../hooks/usePermissionGuard";
import SkeletonTicketList from "../../../loaders/SkeletonTicketList";
import {
  AssignedFeatureAndBenefit,
  CreateFeaturesBenefits,
  ListFeaturesBenefitsCancelToken,
  ListFeaturesBenefitsShortCourseCancelToken,
  ProgrameReArrangeFandB,
  UnlinkFeatureAndBenefit,
  UnlinkShortCourseFeatureAndBenefit,
  shortCourseAssignedFeatureAndBenefit
} from "../../../services/ProgramService";
import { RenderFeatureAndBenefits } from "../../../utils/CommonGroupingItem";
import { RendeFBStatus } from "../../../utils/CommonStatusItems";
import { TABLE_ROWS_PER_PAGE } from "../../../utils/Constants";
import { formatQuestion } from "../../../utils/FormatQuestion";
import { getSortedData, handleTableScroll, sortUtils } from "../../../utils/commonFunction";
import PermissionsGate from "../../../utils/permissionGate";
import HtmlInputEditor from "../../common/HtmlInputEditor";
import Str from "../../common/Str";

const statusArr = [
  {
    value: "1",
    label: HtmlParser(`<span className="red" title="Draft">Draft  </span> `),
  },
  {
    value: "2",
    label: HtmlParser(`<span className="skyblue" title="New"> New </span>`),
  },
  {
    value: "3",
    label: HtmlParser(` <span className="green" title="Final">Final</span>`),
  },
  {
    value: "4",
    label: HtmlParser(
      `<span className="yellowshade" title="Approved">Approved</span>`
    ),
  },
  {
    value: "5",
    label: HtmlParser(
      `<span className="blue" title="Inactive">Inactive</span>`
    ),
  },
];

const FeaturesBenefits = () => {
  const history = useHistory();
  const { id, type, tab } = useParams();

  const [search1, setSearch1] = useState("");
  const [search, setSearch] = useState("");
  const [featuresData, setFeaturesData] = useState({});
  const [topics, setTopics] = useState([]);
  const [loadtopics, setLoadTopics] = useState(true);
  const [dummy, setDummy] = useState();
  const [disabledTopic, setDisabledTopic] = useState(false);
  const [editorState1, setEditorState1] = useState("");
  const [showCkEditor, setShowCkEditor] = useState(false);
  const [availableFeatures, setavailableFeatures] = useState([]);
  const [loadingAvailableFeatures, setLoadingAvailableFeatures] =useState(false);
  const [modalIcon, setModalIcon] = useState(false)
  const [isDisabled, setIsDisabled] = useState(false)
  const [refresh,setRefresh] = useState(false);
  const [renderData, setRenderData] = useState([])
  const [loading,setLoading] = useState(false)

  useEffect(() => {
    handleTableScroll()
  }, [loadingAvailableFeatures, loadtopics])

  useEffect(() => {
    setLoading(true)
    const cancelTokenSources = [];

    const listOfTopics = async () => {
      setLoadTopics(true);
  
      cancelTokenSources.forEach(source => {
        source.cancel('New request made');
      });
  
      const source = axios.CancelToken.source();
      cancelTokenSources.push(source);
  
      try {
        const res = await ListFeaturesBenefitsCancelToken(id, "", source.token);
        if (res.status === 200) {
          setLoading(false);
          const sortedData = getSortedData(res.data.data);
          setTopics(sortedData);
          const formatData = res.data?.data.map(
            (data) => {
                return {
                    ...data,
                    title:data ? <RenderTitle data={data}/> : "N/A",
                }
            }
          )
          setRenderData(formatData)
          setLoadTopics(false);
        }
      } catch (error) {
        if (!axios.isCancel(error)) {
          setLoading(false);
          console.error(error);
          setLoadTopics(false);
        }
      }
    };

    const ListOfAssignFeaturesShortCourse = async () => {
      setLoadTopics(true);
  
      cancelTokenSources.forEach(source => {
        source.cancel('New request made');
      });
  
      const source = axios.CancelToken.source();
      cancelTokenSources.push(source);
  
      try {
        const payload={
          available:0,
          shortcourse_id: 1
        }

        const res = await ListFeaturesBenefitsShortCourseCancelToken(payload, source.token);
        if (res.status === 200) {
          setTopics(res.data.data);
          setLoadTopics(false);
        }
      } catch (error) {
        if (!axios.isCancel(error)) {
          console.error(error);
          setLoadTopics(false);
        }
      }
    };

    if(tab == "features-benefits"){
      listOfTopics();
    }

    if(tab == "shortCourseFeatures-benefits"){
      ListOfAssignFeaturesShortCourse();
    }

    return () => {
      cancelTokenSources.forEach(source => {
        source.cancel('Component unmounted');
      });
    };
  }, [dummy, type,refresh]);

  const handleSaveData = () => {
    setIsDisabled(true);
      let array = []
      for(let d of renderData){
        array.push(
          d.unlink_id
        )
      }
      let dataToSend = {
        assignIds : array
      }
          ProgrameReArrangeFandB(dataToSend).then((res)=>{
              if(res.status===200){
                  Swal.fire({
                      icon: "success",
                      title: "Success",
                      text: `${res?.data?.message}`,
                    }).then(() => {
                      setIsDisabled(false)
                      setRefresh(!refresh)
                    });
              }
          }).catch((err)=>{
            setIsDisabled(false)
              console.log(err);            
              Swal.fire({
                icon: "error",
                title: "error",
                text: `${err?.response?.data[0]?.message}`,
              });
          }).finally(()=>{
            setIsDisabled(false)
              setIsDisabled(false)
          })
  };

  usePermissionGuardRedirect(['pfbview']);
  
  const handleChangeData = (newData) => {
    setRenderData(newData);
  };  
  

  useEffect(() => {
    const cancelTokenSources = [];

    const listOfAvailableFeatures = async () => {
      setLoadingAvailableFeatures(true);
  
      cancelTokenSources.forEach(source => {
        source.cancel('New request made');
      });
  
      const source = axios.CancelToken.source();
      cancelTokenSources.push(source);
      try {

        const res = await ListFeaturesBenefitsCancelToken(id, 1, source.token);
        if (res.status === 200) {
          const sortedData = getSortedData(res.data.data);
          setavailableFeatures(sortedData);
          setLoadingAvailableFeatures(false);
        }
      } catch (error) {
        if (!axios.isCancel(error)) {
          console.error(error);
          setLoadingAvailableFeatures(false);
        }
      }
    };

    const listOfShortCourseAvailableFeatures = async () => {
      setLoadingAvailableFeatures(true);
  
      cancelTokenSources.forEach(source => {
        source.cancel('New request made');
      });
  
      const source = axios.CancelToken.source();
      cancelTokenSources.push(source);
      try {
        const payload={
          available:1,
          shortcourse_id:id
        }
        const res = await ListFeaturesBenefitsShortCourseCancelToken(payload, source.token);
        if (res.status === 200) {
          const sortedData = getSortedData(res.data.data);
          setavailableFeatures(sortedData);
          setLoadingAvailableFeatures(false);
        }
      } catch (error) {
        if (!axios.isCancel(error)) {
          console.error(error);
          setLoadingAvailableFeatures(false);
        }
      }
    };

    if(tab == "features-benefits"){
      listOfAvailableFeatures();
    }
  
    if(tab == "shortCourseFeatures-benefits"){
      listOfShortCourseAvailableFeatures();
    }
  

    return () => {
      cancelTokenSources.forEach(source => {
        source.cancel('Component unmounted');
      });
    };
  }, []);

  const FeatureType = [
    { value: "program", label: "Program" },
    { value: "institute", label: "Institute" },
    { value: "faculty", label: "Faculty" },
  ];

  const resetFilter1 = () => {
    setSearch1("");
  };

  const resetFilterAvailable = () => {
    setSearch("");
  };

  useEffect(() => {
    let updatedData = [];
    let allData = topics;
    if (search1.length) {
      let tempId = allData.filter((item) => {
        let includes = item.name
          .toString()
          .toLowerCase()
          .includes(search1.toLowerCase());
        if (includes) {
          return includes;
        } else return null;
      });
      let tempdata = [...tempId];
      let unique = [...new Set(tempdata)];

      updatedData = unique;
    } else {
      updatedData = allData;
    }
    const formatData = updatedData.map(
      (data) => {
          return {
              ...data,
              title:data ? <RenderTitle data={data}/> : "N/A",
          }
      }
    )
    setRenderData(formatData)

  },[search1])

  const dataToRender = () => {
    let updatedData = [];
    let allData = topics;
    if (search1.length) {
      let tempId = allData.filter((item) => {
        let includes = item.name
          .toString()
          .toLowerCase()
          .includes(search1.toLowerCase());
        if (includes) {
          return includes;
        } else return null;
      });
      let tempdata = [...tempId];
      let unique = [...new Set(tempdata)];

      updatedData = unique;
    } else {
      updatedData = allData;
    }

    if (search1.length) {
      return updatedData;
    } else {
      return topics;
    }
  };

  const dataToRenderAvailable = () => {
    let updatedData = [];
    let allData = availableFeatures;
    if (search.length) {
      let tempId = allData.filter((item) => {
        let includes = item.name
          .toString()
          .toLowerCase()
          .includes(search.toLowerCase());
        if (includes) {
          return includes;
        } else return null;
      });
      let tempdata = [...tempId];
      let unique = [...new Set(tempdata)];

      updatedData = unique;
    } else {
      updatedData = allData;
    }

    if (search.length) {
      return updatedData;
    } else {
      return availableFeatures;
    }
  };

  const handleSearchFilter1 = (e) => {
    const value = e.target.value;
    setSearch1(value);
  };
  const handleSearchAvailableFilter = (e) => {
    const value = e.target.value;
    setSearch(value);
  };

  const handleSort = (column, sortDirection) => {
    const sorted = getSortedData(topics, column.sortField, sortDirection);
    setTopics(sorted);
  };

  const AvailableHandleSort = (column, sortDirection) => {
    const sorted = getSortedData(availableFeatures, column.sortField, sortDirection);
    setavailableFeatures(sorted);
  };

  const exportData = (fileType, fileName) => {
    let data = dataToRender();
    let header = ["Name", "Type", "Status"];
    
    data = data.map((row) => ({
      ...row,
      Name: row.name ? row.name : "-",
      Type: row.type ? RenderFeatureAndBenefits(row.type).text : "-",
      Status: row?.status != null ? RendeFBStatus(row?.status).text : "-",
    }));
    // }

    if (fileType === "csv") {
      const csvString = Papa.unparse({ fields: header, data });
      const blob = new Blob([csvString], { type: "text/csv;charset=utf-8," });

      const blobURL = window.URL.createObjectURL(blob);

      // Create new tag for download file
      const anchor = document.createElement("a");
      anchor.download = fileName;
      anchor.href = blobURL;
      anchor.dataset.downloadurl = [
        "text/csv",
        anchor.download,
        anchor.href,
      ].join(":");
      anchor.click();

      // Remove URL.createObjectURL. The browser should not save the reference to the file.
      setTimeout(() => {
        // For Firefox it is necessary to delay revoking the ObjectURL
        URL.revokeObjectURL(blobURL);
      }, 1000);
    } else if (fileType === "xlsx") {
      const compatibleData = data.map((row) => {
        const obj = {};
        header.forEach((col, index) => {
          obj[col] = row[col];
        });
        return obj;
      });

      let wb = XLSX.utils.book_new();
      let ws1 = XLSX.utils.json_to_sheet(compatibleData, {
        header,
      });
      XLSX.utils.book_append_sheet(wb, ws1, "React Table Data");
      XLSX.writeFile(wb, `${fileName}.xlsx`);

      // Returning false as downloading of file is already taken care of
      return false;
    }
    if (fileType === "pdf") {
      let compatibleData;
      compatibleData = data.map((row) => {
        return [row["Name"], row["Type"], row["Status"]];
      });
      const doc = new JsPDF();
      doc.autoTable({
        head: [header],
        body: compatibleData,
        styles: {
          minCellHeight: 10,
          minCellWidth: 5,
          halign: "left",
          fontSize: 8,
        },
      });
      doc.save(`${fileName}.pdf`);

      return false;
    }
  };

  const exportDataAvailable = (fileType, fileName) => {
    let data, header;
    data = dataToRenderAvailable();
    header = ["Name", "Type", "Status"];
    data = data.map((row) => ({
      ...row,
      Name: row.name ? row.name : "-",
      Type: row.type ? RenderFeatureAndBenefits(row.type).text : "-",
      Status: row?.status != null ? RendeFBStatus(row.status).text: "-",
    }));

    if (fileType === "csv") {
      const csvString = Papa.unparse({ fields: header, data });
      const blob = new Blob([csvString], { type: "text/csv;charset=utf-8," });

      const blobURL = window.URL.createObjectURL(blob);

      // Create new tag for download file
      const anchor = document.createElement("a");
      anchor.download = fileName;
      anchor.href = blobURL;
      anchor.dataset.downloadurl = [
        "text/csv",
        anchor.download,
        anchor.href,
      ].join(":");
      anchor.click();

      // Remove URL.createObjectURL. The browser should not save the reference to the file.
      setTimeout(() => {
        // For Firefox it is necessary to delay revoking the ObjectURL
        URL.revokeObjectURL(blobURL);
      }, 1000);
    } else if (fileType === "xlsx") {
      const compatibleData = data.map((row) => {
        const obj = {};
        header.forEach((col, index) => {
          obj[col] = row[col];
        });
        return obj;
      });

      let wb = XLSX.utils.book_new();
      let ws1 = XLSX.utils.json_to_sheet(compatibleData, {
        header,
      });
      XLSX.utils.book_append_sheet(wb, ws1, "React Table Data");
      XLSX.writeFile(wb, `${fileName}.xlsx`);

      // Returning false as downloading of file is already taken care of
      return false;
    }
    if (fileType === "pdf") {
      let compatibleData;
      compatibleData = data.map((row) => {
        return [row["Name"], row["Type"], row["Status"]];
      });
      const doc = new JsPDF();
      doc.autoTable({
        head: [header],
        body: compatibleData,
        styles: {
          minCellHeight: 10,
          minCellWidth: 5,
          halign: "left",
          fontSize: 8,
        },
      });
      doc.save(`${fileName}.pdf`);

      return false;
    }
  };

  const addAvailableFeature = (row) => {

    if (tab == "shortCourseFeatures-benefits") {
      let dataFeature = {
        shortcourse_id: id,
        feature_benefit_id: row.id,
      };
      shortCourseAssignedFeatureAndBenefit(dataFeature)
        .then((res) => {
          Swal.fire({
            icon: "success",
            title: "Success",
            text: res.data.massage || "Updated Successfully",
          })
          let changeData = availableFeatures;
          let newData = changeData.filter((data) => {
            return data.id != row.id
          })
          setavailableFeatures([...newData])
          setDummy(!dummy);
        })
        .catch((err) => {
          console.log(err);
        });

    } else {
      let dataFeature = {
        programme_id: id,
        feature_benefit_id: row.id,
      };
      AssignedFeatureAndBenefit(dataFeature)
        .then((res) => {
          Swal.fire({
            icon: "success",
            title: "Success",
            text: res.data.massage || "Updated Successfully",
          })
          let changeData = availableFeatures;
          let newData = changeData.filter((data) => {
            return data.id != row.id
          })
          setavailableFeatures([...newData])
          setDummy(!dummy);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const columns = useMemo(() => [
    {
      name: "Name",
      selector: "name",
      sortable: true,
      wrap: true,
      sortFunction: sortUtils.stringSort("name"),
      sortField: "name",
      cell: (row) =>
        row.name ? (
          <PermissionsGate scopes={["pfbedit"]} RenderError={() => (
            <p>{row?.name.trim() ? <span className="feature-name"> <span className="textLimit100">{row.name}</span> </span> : "-"}</p>
          )}>
          <span
            title={row.name}
            onClick={() => {
              setShowCkEditor(true);
              setFeaturesData(row);
              setModalIcon(true);
              formik.setFieldValue("type", row.type);
              if (row.feature_benefit) {
                setEditorState1(row.feature_benefit);
              }
            }}
            className="as-text-blue curser feature-name"
          >
            <span title={row.name} className="textLimit100">{row.name}</span>
          </span>
          </PermissionsGate>
        ) : (
          "-"
        ),
    },
    {
      name: "Type",
      selector: "type",
      sortable: true,
      sortFunction: sortUtils.stringSort("type"),
      wrap: true,
      sortField: "type",
      cell: (row) =>
        row.type ? (
          <span
            className={`as-${
              RenderFeatureAndBenefits(row.type).color
            }-bg as-widget`}
          >
            {" "}
            {RenderFeatureAndBenefits(row.type).text}{" "}
          </span>
        ) : (
          "-"
        ),
    },
    {
      name: "Status",
      selector: "status",
      sortFunction: (rowA, rowB) => {
        const getValue = (row) =>
          row?.status != null
            ? (RendeFBStatus(row.status)?.text || "").toLowerCase()
            : "";
    
        return getValue(rowA).localeCompare(getValue(rowB), undefined, {
          numeric: true,
          sensitivity: "base",
        });
      },
      sortable: true,
      sortField: "status",
      cell: (row) =>
        row?.status != null ? RendeFBStatus(row?.status).html : "-",
    },
    {
      name: "Actions",
      cell: (row) => (
        <div className="assessment-08">
          <div className="as-buttons">
          <PermissionsGate RenderError={() => (
              <button className="btn btn-primary rounded-circle" title="Open" disabled>
                <i className="fal fa-folder-open"></i>
              </button>
            )} scopes={["pfbedit"]}>
            <button
              title="Open"
              className="btn btn-primary rounded-circle"
              onClick={() => {
                setShowCkEditor(true);
                setFeaturesData(row);
                setModalIcon(true)
                formik.setFieldValue("type", row.type);
                if (row.feature_benefit) {
                  setEditorState1(row.feature_benefit);
                }
              }}
            >
              <i className="fal fa-folder-open"></i>
            </button>
          </PermissionsGate>
          <PermissionsGate scopes={["pfbdelete"]} RenderError={() => (
                  <button className="btn btn-danger rounded-circle" title="Unlink" disabled>
                    <i className="fal fa-unlink"></i>
                  </button>
                     )}>
                    <button
                      title="Unlink"
                      className="btn btn-danger rounded-circle"
                      onClick={() => handleDeleteTopic(row.unlink_id)}
                    >
                      <i className="fal fa-unlink"></i>
                    </button>
          </PermissionsGate>
          </div>
        </div>
      ),
    },
  ]);

  const Availablecolumns = useMemo(() => [
    {
      name: "Name",
      selector: "name",
      sortable: true,
      sortFunction: sortUtils.stringSort("name"),
      wrap: true,
      sortField: "name",
      cell: (row) =>
        row.name ? (
          <span
          title={row.name}
          className="as-text-blue curser feature-name"
          onClick={() => {
            Swal.fire({
              title: "Are you sure?",
              icon: "question",
              showCancelButton: true,
              confirmButtonColor: "#3085d6",
              cancelButtonColor: "#d33",
              confirmButtonText: "Yes, Add it!",
            }).then((result) => {
              if (result.isConfirmed) {
                addAvailableFeature(row);
              }
            });
          }}
          >
            <span className="textLimit75">{row.name}</span>
          </span>
        ) : (
          "-"
        ),
      },
      {
        name: "Type",
        selector: "type",
        sortable: true,
        sortFunction: sortUtils.stringSort("type"),
        wrap: true,
        sortField: "type",
        cell: (row) =>
          row.type ? (
            <span
            className={`as-${
              RenderFeatureAndBenefits(row.type).color
            }-bg as-widget`}
            >
            {" "}
            {RenderFeatureAndBenefits(row.type).text}{" "}
          </span>
        ) : (
          "-"
        ),
      },
      {
        name: "Status",
        selector: "status",
        sortFunction: (rowA, rowB) => {
          const getValue = (row) =>
            row?.status != null
              ? (RendeFBStatus(row.status)?.text || "").toLowerCase()
              : "";
      
          return getValue(rowA).localeCompare(getValue(rowB), undefined, {
            numeric: true,
            sensitivity: "base",
          });
        },
        sortable: true,
        sortField: "status",
        cell: (row) =>
          row?.status != null ? RendeFBStatus(row?.status).html : "-",
    },
    {
      name: "Actions",
      cell: (row) => (
        <div className="assessment-08">
          <div className="as-buttons">
            <button
              className="btn btn-primary rounded-circle"
              title="Add"
              type="button"
              onClick={() => {
                Swal.fire({
                  title: "Are you sure?",
                  icon: "question",
                  showCancelButton: true,
                  confirmButtonColor: "#3085d6",
                  cancelButtonColor: "#d33",
                  confirmButtonText: "Yes, Add it!",
                }).then((result) => {
                  if (result.isConfirmed) {
                    addAvailableFeature(row);
                  }
                });
              }}
            >
              <i className="fal fa-plus"></i>
            </button>
          </div>
        </div>
      ),
    },
  ]);

  const handleDeleteTopic = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, remove it!",
    }).then((result) => {
      if (result.isConfirmed) {
        if (tab == "shortCourseFeatures-benefits") {
          UnlinkShortCourseFeatureAndBenefit({ unlink_id: id })
            .then((res) => {
              Swal.fire(
                "Unlinked!",
                "Feature and Benefit has been unlinked.",
                "success"
              );
              setDummy(!dummy);
            })
            .catch((error) => console.log(error));
        } else {
        UnlinkFeatureAndBenefit({ unlink_id: id })
          .then((res) => {
            Swal.fire(
              "Unlinked!",
              "Features and Benefits has been unlinked.",
              "success"
            );
            setDummy(!dummy);
          })
          .catch((error) => console.log(error));
      }
    }
    });
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      feature_benefit: "",
      type: featuresData?.type ? featuresData.type : "",
      name: featuresData?.name ? featuresData.name : "",
      status: featuresData?.status ? featuresData.status : ""
    },
    validationSchema: Yup.object({
      feature_benefit: Yup.string().test(
        "required",
        "Description is Required",
        (value) => {
          let feature = formatQuestion(editorState1);
          let isInvalid = feature == "-";
          return !isInvalid;
        }
      ),
      type: Yup.string().required("Type is required"),
      status: Yup.string().required("Review Status is required"),
      name: Yup.string().required("Name is required").max(255, "Name should not be greater than 255 Character"),
    }),
    onSubmit: (values) => {
      setDisabledTopic(true);
      !featuresData &&
        CreateFeaturesBenefits({
          ...values,
          programme_id: id,
          id: featuresData?.id,
          feature_benefit: editorState1,
        })
          .then((res) => {
            Swal.fire({
              icon: "success",
              title: "Success",
              text: "Added Successfully",
            });
            setDisabledTopic(false);
            setLoadTopics(false);
            setDummy(!dummy);
            formik.resetForm();
            $("#feature-popup").modal("hide");
            setShowCkEditor(false);
          })
          .catch((err) => console.log(err));

      featuresData &&
        CreateFeaturesBenefits({
          ...values,
          programme_id: id,
          id: featuresData?.id,
          feature_benefit: editorState1,
        })
          .then((res) => {
            Swal.fire({
              icon: "success",
              title: "Success",
              text: "Added Successfully",
            });
            setDisabledTopic(false);
            setLoadTopics(false);
            setDummy(!dummy);
            formik.resetForm();
            setFeaturesData({});
            $("#feature-popup").modal("hide");
            setShowCkEditor(false);
          })
          .catch((err) => console.log(err));

     
    },
    
  });

  return (
    <div className="custom-table-div filter-search-icon card card-table-custom">
      <div className="filter-search-head">
        <div className="filter-search-head-left">
          <div className="system-administration-table table-responsive">
            <div className="table-responsive-div">
              <div
                id="assessment-table-main_wrapper"
                className="dataTables_wrapper no-footer"
              >
                <div
                  id="assessment-table-main_filter"
                  className="dataTables_filter"
                >
                  <label>
                    <input
                      type="search"
                      className=""
                      placeholder="Search"
                      aria-controls="assessment-table-main"
                      onChange={handleSearchFilter1}
                      value={search1}
                    />
                  </label>
                  <div className="filter-button-group">
                    <div className="filter-eff filter-data-btn">
                      <button className="filter-buttons">
                        <i className="fal fa-filter"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="filter-search-bar-blk">
              <div className="button-reset dropdown-comman">
                <button
                  className="btn btn-primary"
                  onClick={() => resetFilter1()}
                  title="Reset"
                >
                  <i className="fal fa-redo"></i>Reset
                </button>
              </div>
              <div className="files-export-group">
                <button
                  type="button"
                  className="btn btn-files"
                  onClick={() => {
                    exportData(
                      "xlsx",
                      "Features and Benefits",
                      "Features and Benefits"
                    );
                  }}
                  title="Export spreadsheet"
                >
                  <i className="fal fa-file-excel icon"></i>
                </button>

                <button
                  type="button"
                  className="btn btn-files"
                  onClick={() => {
                    exportData(
                      "csv",
                      "Features and Benefits",
                      "Features and Benefits"
                    );
                  }}
                  title="Export CSV"
                >
                  <i className="fal fa-file-csv icon"></i>
                </button>

                <button
                  type="button"
                  className="btn btn-files"
                  onClick={() => {
                    exportData(
                      "pdf",
                      "Features and Benefits",
                      "Features and Benefits"
                    );
                  }}
                  title="Export PDF"
                >
                  <i className="fal fa-file-pdf icon"></i>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="filter-search-head-right">
          <div className="">
            <button
              className="btn btn-primary mr-2"
              title="Re-Arrange"
              onClick={() => {history.push(`/program-management-center/programmes/features-benefits/${type == 'table' ? 're-arrange' : 'table'}/${id}`)}}
            >
              <i className="fal fa-random"></i>Re-Arrange
            </button>
          <PermissionsGate RenderError={() => (
              <button className="btn btn-primary mr-2" title="Add Feature & Benefit" disabled>Add Feature & Benefit
              </button>
            )} scopes={["pfbadd"]}>
            <button
              className="btn btn-primary mr-2"
              title="Add Feature & Benefit"
              data-toggle="modal"
              data-target="#Select-Features"
            >
              <i className="fal fa-plus"></i>Add Feature & Benefit
            </button>
            </PermissionsGate>
            <PermissionsGate RenderError={() => (
              <button className="btn btn-primary" title="Create New" disabled>Create New
              </button>
            )} scopes={["pfbadd"]}>
            <button
              className="btn btn-primary"
              title="Create New"
              onClick={() => {
                setFeaturesData({});
                setEditorState1("");
                setShowCkEditor(true);
                $("#feature-popup").modal("show");
                setModalIcon(false)
              }}
            >
              <i className="fal fa-plus"></i>Create New
            </button>
            </PermissionsGate>
          </div>
        </div>
      </div>
      {
        type == 'table' ? 
        <DataTable
          data={dataToRender()}
          columns={columns}
          pagination={true}
          progressComponent={<SkeletonTicketList />}
          progressPending={loadtopics}
          onSort={handleSort} 
          noDataComponent={Str.noRecord}
          defaultSortAsc={true}
          defaultSortField={"name"}
          paginationRowsPerPageOptions={TABLE_ROWS_PER_PAGE}
        /> : 
        <>
        <div className="tree-wrapper">
                    {loading ? (
                        <SkeletonTicketList />
                    ) : (
                        <SortableTree
                            theme={TreeTheme}
                            className="my-class"
                            isVirtualized={false}
                            treeData={renderData ? renderData : []}
                            onChange={(treeData) => handleChangeData(treeData)}
                            maxDepth={2}
                            style={{
                                padding: "0px",
                                width: "100%",
                            }}
                            canNodeHaveChildren = {(node)=>(node.type===1)}
                            generateNodeProps={(rowInfo) => {
                                const { node } = rowInfo;
                                return {
                                    canDrop :node.type===0 ? true : false,
                                    class:
                                        node.type === 1
                                            ? "main-category-node just1"
                                            : node.type === 0
                                                ? "sub-category-node just1"
                                                : "item-node just1",
                                    buttons: [
                                        <>
                                        <div className="drag-option-container"> 
                                                
                                                <div className="assessment-08 btn-dropdown-grp">
                                                    <div className="as-buttons">
                                                        <PermissionsGate
                                                        scopes={["pfbedit"]}
                                                        RenderError={() => (
                                                            <button
                                                            className="btn btn-primary rounded-circle"
                                                            title="Open"
                                                            disabled
                                                            >
                                                            <i className="fal fa-folder-open"></i>
                                                            </button>
                                                        )}
                                                        >
                                                        <button
                                                          title="Open"
                                                          className="btn btn-primary rounded-circle"
                                                          onClick={() => {
                                                            setShowCkEditor(true);
                                                            setFeaturesData(rowInfo.node);
                                                            setModalIcon(true)
                                                            formik.setFieldValue("type", rowInfo.node.type);
                                                            if (rowInfo.node.feature_benefit) {
                                                              setEditorState1(rowInfo.node.feature_benefit);
                                                            }
                                                          }}
                                                        >
                                                          <i className="fal fa-folder-open"></i>
                                                        </button>
                                                        </PermissionsGate>
                                                        <PermissionsGate
                                                            scopes={["pfbdelete"]}
                                                            RenderError={() => (
                                                              <button
                                                                className="btn btn-danger rounded-circle"
                                                                title="Unlink"
                                                                disabled
                                                              >
                                                                <i className="fal fa-unlink"></i>
                                                              </button>
                                                            )}
                                                          >
                                                        <button
                                                            className="btn btn-danger rounded-circle"
                                                            title="Unlink"
                                                            onClick={() => handleDeleteTopic(rowInfo.node.unlink_id)}
                                                            >
                                                            <i className="fal fa-unlink"></i>
                                                        </button>
                                                        </PermissionsGate>
                                                    </div>
                                                    </div>                           
                                            </div>
                                                            </>
                                    ],
                                    style: { borderRadius: "10px", width: "100%" },
                                };
                            }}
                            placeholderRenderer={Placeholder}
                        />
                    )}
                </div>
                <div className="form-group form-group-save-cancel mt-3 mb-0">
                <button
                    className="btn btn-primary"
                    type="button"
                    onClick={() => {
                        handleSaveData();
                    }}
                    title="Save"
                    disabled={isDisabled}
                >
                    {isDisabled === false ? <i className="fal fa-save"></i> : <i className="fas fa-cog fa-spin"></i>}
                    Save
                </button>
                <button
                    className="btn btn-close btn-danger"
                    type="button"
                    title="Cancel"
                    onClick={() => (setRefresh(!refresh))}
                >
                    <i className="fal fa-times"></i>Cancel
                </button>
            </div>
            </>
                
        
      }
      {showCkEditor ? (
        <div
          className="topic-add-modal modal fade show able_modal01"
          style={{ display: "block" }}
          id="feature-popup"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="exampleModalCenterTitle"
          aria-hidden="true"
        >
          <div
            className="modal-dialog modal-dialog-centered modal-xl"
            role="document"
          >
            <div className="modal-content">
              <form onSubmit={formik.handleSubmit}>
                <div className="modal-body p-0">
                  <div className="modal-header modal-header-custom">
                    <h5 className="modal-title">
                    {modalIcon ? <><i className="fal fa-folder-open"></i> Edit</> : <><i className="fal fa-plus"></i> Add</>}  Features &amp; Benefits
                    </h5>
                    <button
                      type="button"
                      className="close"
                      data-dismiss="modal"
                      aria-label="Close"
                      onClick={() => {
                        formik.resetForm();
                        $("#feature-popup").modal("hide");
                        setEditorState1("");
                        setShowCkEditor(false);

                        formik.setFieldValue("type", "");
                      }}
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div className="t p-30px">
                    <div className="topic-add-modal-content">
                      <div className="row center-label">
                        <div className="col-md-12">
                          <div className="form-group-blk mb-3">
                            <label>Name *</label>
                            <input
                              type="text"
                              className={
                                "form-control" +
                                (formik.errors.name && formik.touched.name
                                  ? " is-invalid"
                                  : "")
                              }
                              placeholder="Enter Name"
                              name="name"
                              id="name"
                              title="Name"
                              value={formik.values.name}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                            />
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="form-group-blk mb-3">
                            <label>Description *</label>
                            <HtmlInputEditor
                              editorState={editorState1}
                              setEditorState={setEditorState1}
                              hideSign={true}
                              isCKEditor={true}
                              isInvalid={
                                formik.touched.feature_benefit &&
                                formik.errors.feature_benefit
                              }
                            />
                          </div>
                        </div>
                        <div className="col-md-5">
                          <div className="form-group-blk mb-3" title="Type">
                            <label htmlFor="type">Type *</label>
                            <Select
                              className={
                                "form-control custom-select-box" +
                                (formik.errors.type && formik.touched.type
                                  ? " is-invalid"
                                  : "")
                              }
                              name="type"
                              id="type"
                              value={FeatureType.filter((data) => {
                                return data.value == formik.values.type;
                              })}
                              onChange={(value) => {
                                if (value) {
                                  formik.setFieldValue("type", value.value)
                                } else {
                                  formik.setFieldValue("type", "")
                                }
                              }}
                              onBlur={formik.handleBlur}
                              options={FeatureType}
                              maxMenuHeight={175}
                              placeholder={
                                formik.values.type
                                  ? formik.values.type
                                  : "Select Type "
                              }
                              isClearable
                            />
                          </div>
                        </div>
                        <div className="form-group-blk col-md-5" title="Review Status">
                          <label>
                            Review Status *{" "}
                            <i className="fal fa-info-circle grade-icon"></i>
                          </label>
                          <Select
                            className={
                              "form-control custom-select-box" +
                              (formik.errors.status && formik.touched.status
                                ? " is-invalid"
                                : "")
                            }
                            name="status"
                            value={statusArr.filter(
                              (val) => val?.value == formik.values.status
                            )}
                            onChange={(value) => {
                              if (value) {
                                formik.setFieldValue("status", value.value);
                              } else {
                                formik.setFieldValue("status", "");
                              }
                            }}
                            onBlur={formik.handleBlur}
                            options={statusArr}
                            maxMenuHeight={175}
                            placeholder={
                              formik.values.status
                                ? formik.values.status
                                : "Select Review Status  "
                            }
                            isClearable
                          />
                        </div>
                      </div>
                    </div>
                    <div className="form-group form-group-save-cancel mt-3">
                      <button
                        className="btn btn-primary"
                        title="Save"
                        onClick={formik.handleSubmit}
                        disabled={disabledTopic}
                      >
                        {disabledTopic ? (
                          <i className="fas fa-cog fa-spin"></i>
                        ) : (
                          <i className="fal fa-save"></i>
                        )}{" "}
                        Save
                      </button>
                      <button
                        className="btn btn-close btn-danger"
                        type="button"
                        title="Cancel"
                        onClick={() => {
                          formik.resetForm();
                          $("#feature-popup").modal("hide");
                          setEditorState1("");
                          setShowCkEditor(false);

                          formik.setFieldValue("type", "");
                        }}
                      >
                        <i className="fal fa-times"></i>Cancel
                      </button>
                      {Object.keys(formik.values).map((key) => {
                        if (formik.touched[key] && formik.errors[key]) {
                          return (
                            <div className="invalid-feedback d-block">
                              {formik.errors[key]}
                            </div>
                          );
                        }
                      })}
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      ) : null}
      <div
        className="topic-add-modal modal fade"
        id="Select-Features"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalCenterTitle"
        aria-hidden="true"
      >
        <div
          className="modal-dialog modal-dialog-centered available-assessment-modal"
          role="document"
        >
          <div className="modal-content">
          <div className="modal-header modal-header-custom"><h5 className="modal-title"><i className="fal fa-plus"></i> Add Feature & Benefit</h5><button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button></div>
          <div className="modal-body">
            <div className="my-tickets-info-list Tickets-main-wrap tickets-new-custom">
              <div className="custom-table-div filter-search-icon card-table-custom">
                <div className="search-filter-div">
                  <div className="search-filter-div-left">
                  <div className="system-administration-table table-responsive">
                    <div className="table-responsive-div">
                      <div
                        id="assessment-table-main_wrapper"
                        className="dataTables_wrapper no-footer"
                      >
                        <div
                          id="assessment-table-main_filter"
                          className="dataTables_filter"
                        >
                          <label>
                            <input
                              type="search"
                              className=""
                              placeholder="Search"
                              aria-controls="assessment-table-main"
                              onChange={handleSearchAvailableFilter}
                              value={search}
                            />
                          </label>
                          <div className="filter-eff filter-data-btn">
                            <button className="filter-buttons">
                              <i className="fal fa-filter"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="filter-button-group">
                        <div className="button-reset dropdown-comman">
                          <button
                            className="btn btn-primary"
                            onClick={() => resetFilterAvailable()}
                            title="Reset"
                          >
                            <i className="fal fa-redo"></i>Reset
                          </button>
                        </div>
                        <div className="files-export-group">
                          <button
                            type="button"
                            className="btn btn-files"
                            onClick={() => {
                              exportDataAvailable(
                                "xlsx",
                                "Features and Benefits",
                                "Features and Benefits"
                              );
                            }}
                            title="Export spreadsheet"
                          >
                            <i className="fal fa-file-excel icon"></i>
                          </button>

                          <button
                            type="button"
                            className="btn btn-files"
                            onClick={() => {
                              exportDataAvailable(
                                "csv",
                                "Features and Benefits",
                                "Features and Benefits"
                              );
                            }}
                            title="Export CSV"
                          >
                            <i className="fal fa-file-csv icon"></i>
                          </button>

                          <button
                            type="button"
                            className="btn btn-files"
                            onClick={() => {
                              exportDataAvailable(
                                "pdf",
                                "Features and Benefits",
                                "Features and Benefits"
                              );
                            }}
                            title="Export PDF"
                          >
                            <i className="fal fa-file-pdf icon"></i>
                          </button>
                        </div>
                      </div>
                  </div>

                  </div>
                </div>

                <DataTable
                  data={dataToRenderAvailable()}
                  columns={Availablecolumns}
                  pagination={true}
                  progressComponent={<SkeletonTicketList />}
                  progressPending={loadingAvailableFeatures}
                  noDataComponent={Str.noRecord}
                  defaultSortAsc={true}
                  defaultSortField={"name"}
                  onSort={AvailableHandleSort}
                  paginationRowsPerPageOptions={TABLE_ROWS_PER_PAGE}
                />
              </div>
            </div>
          </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeaturesBenefits;
const RenderTitle = ({data}) => {
  return (
      <div className="d-flex justify-content-between">
      <p className="assembly-list-title" title={data.name}>
       <i className="fal fa-list mr-2"></i>
      <span className="as-text-blue">
          {data.name}  
      </span>
    </p>
      </div>
  )
}